export default {
  filters: {
    convertTimeFilter: function (timeInSeconds) {
      if (!timeInSeconds) return '00:00:00';

      let hours = Math.floor(timeInSeconds / 3600);
      let minutes = Math.floor(timeInSeconds / 60 % 60);
      let seconds = timeInSeconds % 60;

      if (hours < 10) hours = '0' + hours;
      if (minutes < 10) minutes = '0' + minutes;
      if (seconds < 10) seconds = '0' + seconds;
      return `${hours}:${minutes}:${seconds}`;
    }
  }
}